import React, { useEffect, useRef, useState } from 'react';
import { markdownToClipboard, writeClipboard } from '../../utils/answerClipboard';
import { trackChatUxEvent } from '../../utils/eventTracker';

const isChatPage = () => typeof window !== 'undefined' && window.location.pathname.startsWith('/chat');

const CopyIcon = () => (
  <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

/** 퀴즈·카드를 문제 → 정답과 해설 글로 복사한다(한글에는 HTML, 카톡에는 글). */
const QuizCopyButton = ({ markdown, label, kind }) => {
  const [state, setState] = useState('idle');
  const timerRef = useRef(null);
  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleCopy = async () => {
    try {
      const clip = markdownToClipboard(markdown);
      const format = await writeClipboard(clip);
      setState('copied');
      if (isChatPage()) trackChatUxEvent('message_copy', { kind, format, responseChars: clip.plain.length });
    } catch (error) {
      setState('failed');
    }
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setState('idle'), 2000);
  };

  const copied = state === 'copied';
  return (
    <button
      aria-label={copied ? `${label} 복사 완료` : `${label} 문제와 정답 복사`}
      className={`wq-quiz__copy ${copied ? 'is-copied' : ''}`}
      onClick={handleCopy}
      type="button"
    >
      <CopyIcon />
      <span>{copied ? '복사됨' : state === 'failed' ? '복사 실패' : '복사'}</span>
    </button>
  );
};

export default QuizCopyButton;
